import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Row } from 'react-bootstrap';
import { TimeInput, DateInput, Input, Select, Static } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';

const min0 = validators.minValue(0);

const SessionForm = ({ error, handleSubmit, pristine, submitSucceeded, initialValues, workshopSessionTypes, t }) => {
	const id = initialValues && initialValues.id;
	const date = initialValues && initialValues.date;
	const typeId = initialValues && initialValues.typeId;
	const typeName = initialValues && initialValues.typeName;

	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Row className='invisible'>
				<Field name='weekId' component={Input} type='hidden' />
			</Row>
			{!id && !date && <DateInput name='date' label={t('Workshop_Session_Date')} validators={validators.required} required horizontal labelCol={4} valueCol={8} />}
			{date && <Field name='date' component={Static} formatType='date' labelSize={4} horizontal label={t('Workshop_Session_Date')} />}
			{typeId && <Field name='typeName' component={Static} horizontal label={t('Workshop_Session_Type')} labelCol={4} valueCol={8} />}
			{!id && !typeId && <Select name='typeId' horizontal required label={t('Workshop_Session_Type')} data={workshopSessionTypes} validate={validators.required} labelCol={4} valueCol={8} />}

			<TimeInput name='startTime' label={t('Workshop_Session_StartTime')} validators={validators.required} required horizontal labelCol={4} valueCol={8} />
			<TimeInput name='endTime' label={t('Workshop_Session_FinishTime')} validators={validators.required} required horizontal labelCol={4} valueCol={8} />
			<Field name='capacity' component={Input} horizontal type='text' placeholder={t('Workshop_Session_UseWorkshopCapacity')}
				label={t('Workshop_Session_Capacity')} validate={[validators.integer, min0]} labelCol={4} valueCol={8} />

		</Form>
	);
};

export default reduxForm({ form: 'session' })(withTranslation()(SessionForm));